module.exports = __webpack_public_path__ + "img/5.42d24fb1.png";